import { useEffect, useState } from "react";
import type { PriceReferenceMode } from "./priceReferenceUtils";

const STORAGE_KEY = "ui.priceReferenceMode";
const DEFAULT_MODE: PriceReferenceMode = "anchored";

export const usePriceReferenceMode = () => {
  const [mode, setMode] = useState<PriceReferenceMode>(() => {
    if (typeof window === "undefined") {
      return DEFAULT_MODE;
    }
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      return stored === "live" || stored === "anchored" ? stored : DEFAULT_MODE;
    } catch (err) {
      return DEFAULT_MODE;
    }
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch (err) {
      // Ignore storage failures.
    }
  }, [mode]);

  return { mode, setMode };
};
